window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from 'vue';
import Swiper from 'swiper';
import VueGoogleMap from 'vuejs-google-maps'


Vue.use(VueGoogleMap, {
    load: {
        apiKey: 'AIzaSyBtGp7e2_dJ1KdMiZFCSeY-LTM-JolAb0I',
        libraries: [/* rest of libraries */]
    }
})
const files = require.context('./', true,  /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const app = new Vue({
    el: '#app',
    data () {
        return {
            defaultMapOptions: {
                zoom: 13,
                minZoom: 3,
                center: {
                    lat: 41.89193,
                    lng: 12.51133
                }
            }
        }
    }
});

var swiper = new Swiper('.swiper-container', {
    slidesPerView: '1',
    loop: true,
    spaceBetween: 0,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.carousel-next',
        prevEl: '.carousel-prev',
    },
    breakpoints: {
        640: {
            slidesPerView: '3'
        }
    }
});

function openModal() {
    document.getElementById("campingLightbox").style.display = "flex";
    document.body.style.overflowY = "hidden";
}

function closeModal() {
    document.getElementById("campingLightbox").style.display = "none";
    document.body.style.overflowY = "auto";
}

let slideIndex = 1;
if (document.getElementsByClassName("campingLightboxSLides").length > 0){
    showSlides(slideIndex);
}

function plusSlides(n) {
    showSlides(slideIndex += n);
}

function currentSlide(n) {
    showSlides(slideIndex = n);
}

function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("campingLightboxSLides");
    if (n > slides.length) {
        slideIndex = 1
    }
    if (n < 1) {
        slideIndex = slides.length
    }
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    slides[slideIndex - 1].style.display = "block";
}

function addClickEventTo(id, callback) {
    let element = document.getElementById(id);
    if (element){
        element.addEventListener("click", () => {
            callback();
        });
    }
}

addClickEventTo("js-openCampingLightbox", function(){
    openModal();
});
addClickEventTo("js-closeCampingLightbox", function(){
    closeModal();
});
addClickEventTo("js-nextSlideCampingLightbox", function(){
    plusSlides(-1);
});
addClickEventTo("js-previousSlideCampingLightbox", function(){
    plusSlides(1);
});
//

[...document.querySelectorAll('a[title=Webshop]')].forEach(function(element){
    element.setAttribute('target','_blank');
    console.log(element.attributes);
});
